import company from '~/assets/icons/company.svg';
import exit from '~/assets/icons/exit.svg';
import group from '~/assets/icons/group_2.svg';
import info from '~/assets/icons/info_2.svg';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { SectionHeading } from '~/components/ui/SectionHeading';
import { Text } from '~/components/ui/Text';
import { AppTruckJobActiveOrder } from '../AppTruckJobActiveOrder';
import { AppTruckJobGroupMember } from '../AppTruckJobGroupMember';
import {
	StyledAddFriendsContainer,
	StyledAddFriendsItem,
	StyledAddFriendsList,
	StyledButtonContent,
	StyledContainer,
	StyledHeadTitleContainer,
	StyledInfoBlock,
	StyledLeftButtonContainer,
	StyledLeftContainer,
	StyledMembersContainer,
	StyledMembersHead,
	StyledNotActiveOrderContainer,
	StyledNotActivePlayersList,
	StyledRightContainer,
} from './AppTruckJobMyGroup.styled';

import { ScrollContainer } from '~/components/ui/ScrollContainer';

const AppTruckJobMyGroup = () => {
	const isLeader = false;
	const addFriendsActive = true;
	const orderActive = true;
	const notActivePlayers = false;

	return (
		<StyledContainer>
			<StyledLeftContainer>
				<StyledHeadTitleContainer>
					<img src={group} />
					<Text>Мой конвой</Text>
				</StyledHeadTitleContainer>
				<StyledInfoBlock>
					<img src={info} />
					<Text>
						Создавая конвой, вы увеличиваете заработок за обычные заказы и
						контракты
					</Text>
				</StyledInfoBlock>
				<StyledMembersHead>
					<SectionHeading text="Мой конвой" icon={company} />
					<Text style={{ fontSize: 16, color: '#ffffff' }}>
						<span style={{ opacity: 0.5 }}>Участники:</span>{' '}
						<span style={{ fontWeight: 500, color: '#1AB248' }}>3</span>{' '}
						<span style={{ fontSize: 14, opacity: 0.25 }}>/ 4</span>
					</Text>
				</StyledMembersHead>
				<StyledMembersContainer>
					<AppTruckJobGroupMember
						name="Artem Bakhia"
						isLeader={true}
						isMe={true}
						canEdit={false}
					/>
					<AppTruckJobGroupMember
						name="Dmitry Stepanov"
						isLeader={false}
						isMe={false}
						canEdit={true}
					/>
					<AppTruckJobGroupMember
						name="Vlad Jevico"
						isLeader={false}
						isMe={false}
						canEdit={true}
					/>
					<AppTruckJobGroupMember
						name="Max Volla"
						isLeader={false}
						isMe={false}
						canEdit={true}
					/>
				</StyledMembersContainer>
				<StyledLeftButtonContainer>
					{isLeader ? (
						<Button
							color={ButtonColors.Select2}
							height={ButtonHeight.Height50}
							style={{ fontSize: 16 }}
						>
							<Text style={{ fontWeight: 500 }}>Добавьте игроков в конвой</Text>
						</Button>
					) : (
						<Button
							color={ButtonColors.Cancel}
							height={ButtonHeight.Height50}
							style={{ fontSize: 16 }}
						>
							<StyledButtonContent>
								<img src={exit} width={20} height={20} />
								<Text style={{ fontWeight: 500 }}>Выйти из конвоя</Text>
							</StyledButtonContent>
						</Button>
					)}
				</StyledLeftButtonContainer>
			</StyledLeftContainer>

			<StyledRightContainer>
				{addFriendsActive ? (
					<StyledAddFriendsContainer>
						<SectionHeading icon={group} text="Игроки рядом" />
						{notActivePlayers ? (
							<StyledNotActivePlayersList>
								<Text>Нет игроков поблизости</Text>
							</StyledNotActivePlayersList>
						) : (
							<ScrollContainer
								height={468}
								style={{ paddingRight: 20 }}
								scrollbarRight={-10}
								showMask
							>
								<StyledAddFriendsList>
									{new Array(20).fill(0).map((_, index) => (
										<StyledAddFriendsItem key={index}>
											<Text>Artem Bakhia</Text>
											<Button
												color={ButtonColors.Select2}
												height={ButtonHeight.Height30}
												borderRadius={ButtonBorderRadius.Radius5}
												style={{ fontWeight: 500, width: 95 }}
											>
												<Text>Пригласить</Text>
											</Button>
										</StyledAddFriendsItem>
									))}
								</StyledAddFriendsList>
							</ScrollContainer>
						)}
						<Button
							color={ButtonColors.Default}
							height={ButtonHeight.Height50}
							style={{ fontSize: 16, marginTop: 'auto' }}
						>
							<Text style={{ fontWeight: 500 }}>Обновить список игроков</Text>
						</Button>
					</StyledAddFriendsContainer>
				) : orderActive ? (
					<AppTruckJobActiveOrder />
				) : (
					<StyledNotActiveOrderContainer>
						<Text>Ожидание лидера конвоя</Text>
					</StyledNotActiveOrderContainer>
				)}
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { AppTruckJobMyGroup };
